import React, {useEffect, useContext, useCallback} from 'react'
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { getNotifier } from '../../../../../services/notifier';
import { ApiContext } from '../../../../../services/api/api-config';
import  useFormState from '../../../../../hooks/useFormState';
import { SideMenu } from '../../../../../components/Dashboard/SideMenu/SideMenu';
import TopBar from '../../../../../components/Dashboard/TopBar/TopBar';
import { SectionTitle } from '../../../../../components/Dashboard/SectionTitle/SectionTitle';
import Card from '../../../../../components/Dashboard/Card/Card';
import TextInput from '../../../../../components/forms/TextInput/TextInput';
import Button from '../../../../../components/molecules/Button/Button';
import {catMaterialStatusTableSGroups} from '../CatMaterialStatusUtils';
import { paths } from '../../../../../services/routes/appRoutes';
import "./CatMaterialStatusForm.scss";

export default function CatMaterialStatusForm() {

  const { id } = useParams();
  const api = useContext(ApiContext);
  const navigate = useNavigate();
  const { form, setForm, bindInput } = useFormState({});
  const loadingId = `Grower.form.${id}`;

  useEffect(() => {
    if (id) {
      api.catMaterialStatuses.get(
        {
          id,
          params: {sGroups: catMaterialStatusTableSGroups}
        }
      )
        .then(async(materialStatus) => {
          setForm( materialStatus );
        })
        .catch(error => getNotifier().error(error.detail || error.message));
    }
  }, [api, id, setForm]);

  /**
   * Handle create or update material status
   */
  const handleCreateOrUpdateMaterialStatus = useCallback(() => {
    const {id} = form;
    const method = id ? 'update' : 'create';
    let materialStatus = null;

    try {
      // brand = prepareBrandForServer(form);
      materialStatus = form;
    } catch (error) {
      return getNotifier().error(error.message||error.detail);            
    }
    
    api.catMaterialStatuses[method]({ id, params: materialStatus })
      .then(materialStatus => {
        getNotifier().success(
          id ? 'Actualizado correctamente' : 'Agregado correctamente'
        );
        navigate(paths.catMaterialStatus);
      }
    )
      .catch(error => getNotifier().error(error.message || error.detail));
  }, [api, form, navigate]);

  const loading = useSelector(s => !!s.loadingIds[loadingId]);

  return (
    <div className="CatMaterialStatusForm dashboard-container">
      <SideMenu />
      <div className='right-content'>
        <TopBar />
        <div className='main-content'>
          <SectionTitle>
            { !id ? 'AGREGAR ESTATUS DE MATERIAL' : 'EDITAR ESTATUS DE MATERIAL' }
          </SectionTitle>
          <div className='row'>
            <Card className='OrderStep1'>
              <div className='row mt-3'>
                <div className='col-12 margin-top-mobile'>
                  <TextInput
                    label="Estatus"
                    placeholder=""
                    {...bindInput('name')}
                    inputProps={
                      {maxLength: 50}
                    }
                  />
                </div>
              </div>
                      
              <div className='d-flex justify-content-center align-items-center buttons-container'>
                <Button
                  className={'btn-primary btn-outline'}
                  onClick={() => window.location.href = paths.catMaterialStatus }
                  design={'clear'}
                >
                  Cancel
                </Button>
                <Button 
                  className={`btn-primary btnNextStep`}
                  onClick={handleCreateOrUpdateMaterialStatus}
                  disabled={loading}
                >
                  { id ? 'Actualizar' : 'Agregar' }
                </Button>
              </div>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
}
